import { Case } from '@tecex-api/data';
import isNil from 'lodash/isNil';
import { SendbirdChannelsList } from '../interfaces/messages/sendbird-channel-list.interface';

export const filterEmptyCase = (item: Case): boolean => !isNil(item);
export const filterEmptySendbirdCase = (item: SendbirdChannelsList): boolean => !isNil(item);
